import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  BulkIssuance,
} from '@nymos/bulkcards/core';


@Component({
  selector: 'nym-issuance-listing',
  templateUrl: './issuance-listing.component.html',
  styleUrls: ['./issuance-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuanceListingComponent implements OnInit {

  @HostBinding('class.nym-issuance-listing')
  protected get classes(): boolean { return true; }

  @Output()
  protected clone: EventEmitter<BulkIssuance> = new EventEmitter();

  @Output()
  protected create: EventEmitter<any> = new EventEmitter();

  @Output()
  protected loadMore: EventEmitter<any> = new EventEmitter();

  @Input()
  public title: string;

  @Input()
  public issuances: BulkIssuance[];

  @Input()
  public loading: boolean;

  @Input()
  public hasMore: boolean;

  @Input()
  public columns: string[];

  constructor() { }

  public ngOnInit(): void { }

  protected create$$(): void {
    this.create.emit();
  }

  protected clone$$(issuance: BulkIssuance): void {
    this.clone.emit(issuance);
  }

  protected loadMore$$(): void {
    this.loadMore.emit();
  }

}
